"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = ({
  size = 24,
  width = size,
  height = size,
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.9012 6.47368C13.9012 7.56372 13.0236 8.44737 11.941 8.44737C10.8584 8.44737 9.98078 7.56372 9.98078 6.47368C9.98078 5.38365 10.8584 4.5 11.941 4.5C13.0236 4.5 13.9012 5.38365 13.9012 6.47368ZM19.7819 17.5263C19.7819 18.6163 18.9043 19.5 17.8217 19.5C16.7391 19.5 15.8615 18.6163 15.8615 17.5263C15.8615 16.4363 16.7391 15.5526 17.8217 15.5526C18.9043 15.5526 19.7819 16.4363 19.7819 17.5263ZM13.9012 13.5789C13.9012 14.669 13.0236 15.5526 11.941 15.5526C10.8584 15.5526 9.98078 14.669 9.98078 13.5789C9.98078 12.4889 10.8584 11.6053 11.941 11.6053C13.0236 11.6053 13.9012 12.4889 13.9012 13.5789ZM8.02055 17.5263C8.02055 18.6163 7.14293 19.5 6.06033 19.5C4.97772 19.5 4.1001 18.6163 4.1001 17.5263C4.1001 16.4363 4.97772 15.5526 6.06033 15.5526C7.14293 15.5526 8.02055 16.4363 8.02055 17.5263Z",
  fill: "white"
}));

exports.default = _default;